import React, { useEffect, useState } from 'react'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import AdOrgPost from '../../../components/AdOrgPost'
import Loader from '../../../components/Loader'
import PreviousPostAdCard from '../../../components/PreviousPostAdCard'

const AdSelector = () => {
    const [posts, setPosts] = useState([])
    const [previousAds, setPreviousAds] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const { organization } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        getContent()
    }, [])

    const getContent = async () => {
        try {
            setIsLoading(true)
            const response = await api.get(`/${organization}/manage/promotions`)
            setIsLoading(false)

            if (response) {
                setPosts(response.data.posts)
                setPreviousAds(response.data.previousAds)
            }
        } catch (error) {
            setIsLoading(false)
            toast.error(error.response.data.message)
        }
    }
    return (
        <div>
            <h2 className="header-title">Posts You can Promote</h2>
            {
                isLoading ? <Loader /> : <div className="ads-selector">
                    <div className="ads-select">
                        <h3>Promote Posts</h3>
                        {!isLoading && !posts?.length && <p>No posts found</p>}

                        {
                            posts?.map((post) => (
                                <AdOrgPost postAd={post} />
                            ))
                        }
                        <button onClick={() => navigate(`/${organization}/admin/promotions/posts`)}>See more</button>
                    </div>
                    <div className="ads-select">
                        <h3>Promote Previous ads</h3>
                        {!isLoading && !previousAds?.length && <p>No previous promotions found</p>}
                        {
                            previousAds.map((ad) => (
                                <PreviousPostAdCard key={ad._id} ad={ad} />
                        ))
                        }
                        <button onClick={() => navigate(`/${organization}/admin/promotions/previous`)}>See more</button>
                    </div>
                </div>
            }
        </div>
    )
}

export default AdSelector